import { useContext } from "react";

import { ContentfulFormalizrContext } from "@utils/context/ContentfulFormalizerContext";

const useContentfulFormalizr = () => {
    const context = useContext(ContentfulFormalizrContext);

    if (!context) {
        throw new Error(
            "useContentfulFormalizer must be used within a ContentfulFormalizerProvider",
        );
    }

    return context;
};

export default useContentfulFormalizr;
